/**
 * SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
 * Copyright (C) 2021 SalesAgility Ltd.
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License version 3 as published by the
 * Free Software Foundation with the addition of the following permission added
 * to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
 * IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
 * WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 *
 * In accordance with Section 7(b) of the GNU Affero General Public License
 * version 3, these Appropriate Legal Notices must retain the display of the
 * "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
 * feasible for technical reasons, the Appropriate Legal Notices must display
 * the words "Supercharged by SuiteCRM".
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RecordContainerComponent} from './record-container.component';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {WidgetPanelModule} from '../../../../components/widget-panel/widget-panel.module';
import {
    SubpanelContainerModule
} from '../../../../containers/subpanel/components/subpanel-container/subpanel-container.module';
import {
    SidebarWidgetModule
} from '../../../../containers/sidebar-widget/components/sidebar-widget/sidebar-widget.module';
import {TopWidgetModule} from '../../../../containers/top-widget/components/top-widget/top-widget.module';
import {RecordContentModule} from '../../../../components/record-content/record-content.module';
import {
    RecordContentSkeletonModule
} from '../../../../components/record-content-skeleton/record-content-skeleton.module';
import {RecordPaginationComponent} from "../record-pagination/record-pagination.component";

@NgModule({
    declarations: [RecordContainerComponent],
    exports: [RecordContainerComponent],
    imports: [
        CommonModule,
        WidgetPanelModule,
        AngularSvgIconModule,
        SubpanelContainerModule,
        RecordContentModule,
        TopWidgetModule,
        SidebarWidgetModule,
        RecordContentSkeletonModule,
        RecordPaginationComponent
    ]
})
export class RecordContainerModule {
}
